import { Suspect } from './Suspect';
import { useNicheSuspect } from './useNicheSuspect';

export function HighPrioritySuspect({
  recordId,
  onOptionClick,
  onShowMapClick,
}) {
  const {
    query: { data: suspect },
  } = useNicheSuspect(recordId);

  return suspect ? (
    <Suspect
      suspect={suspect}
      onOptionClick={onOptionClick}
      onShowMapClick={onShowMapClick}
    />
  ) : null;
}
